<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" syear semester semester-nonall ssystem college department sclass keyword="學號、學生姓名">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.house" id="house" label="宿舍">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in houses" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                    <div class="col-md col-sm-12">
                        <form-input v-model="query.room" id="room" label="寢室" type="text"></form-input>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input" :file="file"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>宿舍</th>
                            <th>寢室</th>
                            <th>床號</th>
                            <th>學號-學生姓名</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.DormitoryID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.DormitoryID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="宿舍">{{item.House|house}}</td>
                        <td data-th="寢室">{{item.Room}}</td>
                        <td data-th="床號">{{item.No}}</td>
                        <td data-th="學號-學生姓名"><b-button size="sm" variant="link" @click="edit(item.DormitoryID)">{{item.StudentNo}}-{{item.StudentName}}</b-button></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="house">
                <div is="option" v-for="o in houses" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
        <inputmodal id="input" sample="/template/dormitory.xlsx" url="/api/dormitory/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './dormitoryDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'dormitory',
        api: '/api/dormitory/',
        components: { Detail },
        data: { houses: [] },
        created: function () {
            window.houses = [];
            this.$parameter.house().then((res) => { window.houses = this.houses = res.data; });
        },
        filters: {
            house: function (value) { let a = window.houses.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
        methods: {
            file: function () {
                const $a = document.createElement("a");
                $a.href = this.$apiurl + "/api/dormitory/output?" + new URLSearchParams(this.query).toString();
                $a.click();
            }
        }
    });
</script>

<style>
</style>